import {
  IconButton,
  Typography,
  CardMedia,
  LinearProgress,
  Grid,
  Tooltip,
  Button,
} from '@mui/material';
import { Box } from '@mui/system';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { Link as RouterLink, useParams } from 'react-router-dom';
import {
  FatcaMdmsData,
  getApplicationDetails,
  getDocuments,
  nonIndividualFormValidForSubmission,
  updateApplication,
} from '../../redux-store/actions/application';
import {
  ApplicationProps,
  FatcaMdms,
  Groups,
  individuals_Poa_nonIndividuals_Documents,
  nationaliyType,
  RiskProfileMaster,
} from '../../redux-store/types/api-types';
import { ApplicationTimeline, RejectedDetails } from '../ApplicationDetails';
import { AmlDetails, CommonLayout, ConfirmationDialog } from '../commonComponents';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import {
  USER_ROLES,
  ApplicationStatusBasedOnRole,
  REJECTED_ROLES,
  IndividualApplicationStatusBasedOnRole,
  APPLICATION_LISTING_STATUS,
} from '../../utils/constant';
import { formatShortDateAndTime } from '../../utils/date';
import {
  applyRoleBasedStatus,
  isNotAdvisoryFlow,
  checkIfApplicationIsNonIndividual,
  getAllStrategiesByDistributorType,
  isPendingByAMCAuthorisedSignatory,
  isPhygital,
} from '../../utils/utilityFunctions';
import ContributorDetails from './ContributorDetails';
import { RootStateType } from '../../redux-store/reducers';
import ContactDetails from './ContactDetails';
import BankDetails from '../ApplicationDetails/BankDetails';
import AuthorizedSignatories from './AuthorisedSignatories';
import Documents from './Document';
import Ubo from './ubo';
import Fatca from './fatca';
import { useRouteMatch } from 'react-router';
import DistributorDetails from '../ApplicationDetails/rmDistributor';
import RiskProfiles from '../ApplicationDetails/RiskProfiles';
import StrategyDetails from '../ApplicationDetails/strategyDetails';
import DisclosureOfInterest from '../ApplicationDetails/disclosureOfInterest';
import DisclosureOfExclusions from '../ApplicationDetails/disclosureOfExclusions';
import RelatedPartyConsent from '../ApplicationDetails/relatedPartyConsent';
import {
  getNationalityList,
  getStatesList,
  riskProfileMasterData,
} from '../../redux-store/actions';
import { GetStrategiesResponseBody } from '../../redux-store/types/strategies';
import { showError } from '../../redux-store/actions/auth';
import DisplayImgForAuthorizedSignatories from './authorisedSignatoriesDisplayImg';
import AuthorizedSignatoriesDocuments from './AuthorizedSignatoriesDocuments';
import Comments from '../ApplicationDetails/Comments';
import CloseIcon from '@mui/icons-material/Close';
import { Formik } from 'formik';
import { MFTextField } from '../../lib/formik';
import { LoadingButton } from '@mui/lab';
import * as yup from 'yup';
import HistoryIcon from '@mui/icons-material/History';
import { getAuthorizedSignatoriesConsentDetails } from '../dashboard/applicationslist';
import { documentDetails } from '../investors/documentDetails';
import { statesType } from '../../redux-store/types/mdms';
import PhygitalDocumentDetails from '../ApplicationDetails/PhygitalDocumentDetails';
import { AccessibleDialog } from '../../lib/AccessibleDialog';

export const filterSignatoryData = (documentData: documentDetails[]): documentDetails[] => {
  return documentData?.filter((groupData) => {
    return groupData.documentType === 'typedDeclaration';
  });
};

const filterSignatoryDocuments = (groups: Groups[]): Groups[] => {
  return groups.map((groupData) => ({
    ...groupData,
    groupsignatories: groupData.groupsignatories
      .map((signatoryData, index) => ({
        ...signatoryData,
        indexId: index,
        groupsignatorydocuments: filterSignatoryData(signatoryData.groupsignatorydocuments),
      }))
      .filter((signatoryData) => signatoryData.groupsignatorydocuments.length > 0),
  }));
};

export const NonIndividualApplicationLayout = ({
  loading,
  application,
}: {
  loading: boolean;
  application: ApplicationProps;
}): JSX.Element => {
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const { groups = [] } = application || {};
  const authorizedSignatoriesReferenceDetail = useSelector(
    (store: RootStateType) => store.authorizedSignatoriesRefrenceIdReducer
  );
  return (
    <>
      {loading && <LinearProgress />}
      {application && (
        <>
          <Box
            sx={{
              bgcolor: 'white',
              boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
              borderRadius: '10px',
            }}
            mb={3}>
            <Box sx={{ p: 2 }}>
              <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
                <Grid
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="flex-start"
                  mb={2}>
                  <Typography
                    component="h2"
                    sx={{
                      fontSize: 18,
                      fontWeight: 600,
                      color: 'text.secondary',
                    }}>
                    Application ID: {application.applicationNumber}
                  </Typography>
                  {application.folio_no && (
                    <Typography
                      component="h2"
                      sx={{
                        fontSize: 18,
                        fontWeight: 600,
                        color: 'text.secondary',
                      }}>
                      Folio Number: {application.folio_no}
                    </Typography>
                  )}
                  <Typography
                    component="h3"
                    className={
                      application.hasPOA
                        ? role === USER_ROLES.POAAPPROVER
                          ? ApplicationStatusBasedOnRole[role][application.status]
                          : APPLICATION_LISTING_STATUS[application.status]
                        : checkIfApplicationIsNonIndividual(application)
                        ? role === USER_ROLES.AMCAPPROVER
                          ? ApplicationStatusBasedOnRole[role][application.status]
                          : APPLICATION_LISTING_STATUS[application.status]
                        : !checkIfApplicationIsNonIndividual(application) &&
                          role === USER_ROLES.AMCAPPROVER
                        ? IndividualApplicationStatusBasedOnRole[role][application.status]
                        : APPLICATION_LISTING_STATUS[application.status]
                    }
                    sx={{
                      fontSize: 18,
                      fontWeight: 600,
                      color: 'text.secondary',
                      '&.Draft .MuiTypography-root': {
                        color: '#2057A6',
                      },
                      '&.Completed .MuiTypography-root': {
                        fontWeight: 600,
                        color: '#4B8251',
                      },
                      '&.Rejected .MuiTypography-root': {
                        color: '#BD2932',
                        fontWeight: 500,
                      },
                      ...(application.status === 'esign_failed' && {
                        '& .MuiTypography-root': {
                          color: '#BD2932',
                          fontWeight: 500,
                        },
                      }),
                    }}>
                    Status:
                    <Typography
                      component="span"
                      sx={{
                        color: '#996E09',
                        fontSize: '16px',
                        letterSpacing: '0.4px',
                        ml: 0.5,
                      }}>
                      {USER_ROLES.AMCAUTHORISEDSIGNATORY === role &&
                      isPendingByAMCAuthorisedSignatory(application.status)
                        ? 'Pending'
                        : application.hasPOA
                        ? role === USER_ROLES.POAAPPROVER
                          ? ApplicationStatusBasedOnRole[role][application.status]
                          : APPLICATION_LISTING_STATUS[application.status]
                        : checkIfApplicationIsNonIndividual(application)
                        ? role === USER_ROLES.AMCAPPROVER
                          ? ApplicationStatusBasedOnRole[role][application.status]
                          : APPLICATION_LISTING_STATUS[application.status]
                        : !checkIfApplicationIsNonIndividual(application) &&
                          role === USER_ROLES.AMCAPPROVER
                        ? IndividualApplicationStatusBasedOnRole[role][application.status]
                        : APPLICATION_LISTING_STATUS[application.status]}
                    </Typography>
                  </Typography>
                  {[
                    USER_ROLES.RM,
                    USER_ROLES.SRM,
                    USER_ROLES.DISTRIBUTOR,
                    USER_ROLES.SUBDISTRIBUTOR,
                    USER_ROLES.AMCAPPROVER,
                    USER_ROLES.AMC_ADMIN,
                  ].includes(role) &&
                    application.signedLeegalityFile?.url && (
                      <Tooltip title={'Download'}>
                        <IconButton
                          sx={{
                            p: 0,
                            pr: 0.5,
                            ':hover': {
                              bgcolor: '#F4FCFC',
                            },
                            cursor: 'pointer',
                            pointerEvents: 'all',
                          }}
                          onClick={() =>
                            application.signedLeegalityFile?.url &&
                            window.open(application.signedLeegalityFile?.url)
                          }>
                          <CardMedia
                            component="img"
                            src={'/images/download-icon.png'}
                            alt="Download"
                            sx={{ width: '25px' }}
                          />
                        </IconButton>
                      </Tooltip>
                    )}
                </Grid>
                {application.status === 'rejected' && (
                  <Grid
                    item
                    container
                    pb={5}
                    rowSpacing={1}
                    columnSpacing={13}
                    direction="row"
                    justifyContent="space-between"
                    alignItems="flex-start">
                    <RejectedDetails
                      title={'Rejected by'}
                      description={REJECTED_ROLES[application.rejectedByRole]}
                    />
                    <RejectedDetails
                      title={'Rejected on'}
                      description={formatShortDateAndTime(application.rejectedAt)}
                    />
                    <RejectedDetails
                      title={'Reason for rejection'}
                      description={application.rejectedReason}
                    />
                  </Grid>
                )}
              </Grid>
            </Box>
          </Box>
          {!authorizedSignatoriesReferenceDetail.referenceId && (
            <AmlDetails
              applicants={application.applicants}
              applicationType={application.applicationType}
            />
          )}

          {groups
            .map((group) => {
              return (
                group.groupsignatories.filter((signatories) => !signatories.referenceId).length !==
                group.groupsignatories?.length
              );
            })
            .includes(true) &&
            groups.some((group) =>
              group.groupsignatories?.some((_signatory) => _signatory.photocaptureStatus)
            ) && (
              <DisplayImgForAuthorizedSignatories
                authorisedSignatores={groups
                  .map((group) => {
                    return {
                      ...group,
                      groupsignatories: group.groupsignatories?.filter(
                        (_signatory) => _signatory.photocaptureStatus
                      ),
                    };
                  })
                  .flat()}
                editable={!application?.signDetails?.url}
              />
            )}
          {!authorizedSignatoriesReferenceDetail.referenceId && application.comments.length > 0 && (
            <Comments application={application} />
          )}
          <DistributorDetails application={application} />
          <ContributorDetails application={application} />
          <ContactDetails application={application} />
          {/* <InvestAndPaymentDetails application={application} /> */}
          {isNotAdvisoryFlow(application?.accountType || '') && (
            <BankDetails application={application} />
          )}

          <Documents application={application} />

          <AuthorizedSignatories groups={application.groups} />
          <Ubo application={application} />
          <RiskProfiles application={application} />
          <StrategyDetails application={application} />
          <DisclosureOfInterest application={application} />
          <DisclosureOfExclusions application={application} />
          {isNotAdvisoryFlow(application?.accountType || '') && (
            <RelatedPartyConsent application={application} />
          )}
          <Fatca applicants={application.applicants} />
          {isPhygital(application) && application?.signedLeegalityDocumentId && (
            <PhygitalDocumentDetails application={application} />
          )}
          {authorizedSignatoriesReferenceDetail.referenceId
            ? filterSignatoryData(
                application?.groups
                  ?.find(
                    (_groupSignatory) =>
                      Number(_groupSignatory.id) ===
                      Number(authorizedSignatoriesReferenceDetail.groupId)
                  )
                  ?.groupsignatories?.find(
                    (_signatory) =>
                      Number(_signatory.id) === Number(authorizedSignatoriesReferenceDetail.id)
                  )?.groupsignatorydocuments || []
              )?.length > 0 && (
                <AuthorizedSignatoriesDocuments
                  groups={filterSignatoryDocuments(application.groups)}
                  custodian={application?.custodian || ''}
                />
              )
            : application.groups
                .map((_group) => {
                  return _group.groupsignatories.map((_signatory) =>
                    _signatory.groupsignatorydocuments &&
                    _signatory.groupsignatorydocuments.length > 0 &&
                    filterSignatoryData(_signatory.groupsignatorydocuments).length > 0
                      ? true
                      : false
                  );
                })
                .flat()
                .some((ele) => ele === true) && (
                <AuthorizedSignatoriesDocuments
                  groups={filterSignatoryDocuments(application.groups)}
                  custodian={application?.custodian || ''}
                />
              )}
        </>
      )}
    </>
  );
};

//Read only view for RM, Distributor, Subdistributor
export const NonIndividualApplicationDetail = (): JSX.Element => {
  const { id } = useParams<{ id: string }>();
  const history = useHistory();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [application, setApplication] = useState<ApplicationProps>();
  const applicationDetailRef = useRef<HTMLDivElement>();
  const { path } = useRouteMatch();
  const [openDialog, setDialog] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const [dialogOpen, setDialogOpen] = useState(false);
  const authorizedSignatoriesReferenceDetail = useSelector(
    (store: RootStateType) => store.authorizedSignatoriesRefrenceIdReducer
  );

  const {
    editable,
    hasPOA,
    applicationSentBack = false,
    documentSentBack = false,
  } = application || {};
  const initialCommentValues: Partial<ApplicationProps> = { comment: '' };
  const Commentvalidation = yup.object().shape({
    comment: yup.string().required('Please provide Comment'),
  });
  const handleSendBack = () => setOpenSendBackDialog(true);
  const [openSendBackDialog, setOpenSendBackDialog] = useState(false);
  const [sendBackLoading, setSendBackLoading] = useState(false);
  const handleSendBackClose = () => {
    setOpenSendBackDialog(false), setSendBackLoading(false);
  };
  const onSendBackSubmit = async (values: Partial<ApplicationProps>) => {
    try {
      handleSendBackClose();
      setSendBackLoading(true);
      const { id, status } = application || {};
      const updatedPayload =
        application?.status === 'pending_physical_sign'
          ? {
              documentComment: values.comment,
              documentSentBack: false,
            }
          : {
              comment: values.comment,
              applicationSentBack: false,
            };
      if (id) {
        await dispatch(
          updateApplication({
            body: {
              ...application,
              status:
                application?.status === 'pending_physical_sign' && applyRoleBasedStatus(role)
                  ? 'sent_for_document_approval'
                  : 'sent_to_amc_approver',
              ...updatedPayload,
            },
            applicationId: id,
          })
        );
        history.push('/applications');
      }
    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setSendBackLoading(false);
    }
  };

  useEffect(() => {
    let isComponentActive = true;
    (async function () {
      try {
        setLoading(true);
        const _application = (await dispatch(
          getApplicationDetails(id)
        )) as unknown as ApplicationProps;
        if (!isComponentActive) return;
        setApplication(_application);
      } catch (e) {
        console.log(e);
      } finally {
        if (isComponentActive) setLoading(false);
      }
    })();
    return () => {
      isComponentActive = false;
    };
  }, []);

  const handleSubmit = async () => {
    try {
      const { id } = application || {};
      setIsSubmitting(true);
      if (id) {
        await dispatch(
          updateApplication({
            body: {
              ...application,
              status:
                application?.status === 'pending_physical_sign' && applyRoleBasedStatus(role)
                  ? 'sent_for_document_approval'
                  : 'sent_to_amc_approver',
            },
            applicationId: id,
          })
        );
        history.push('/applications');
      }
    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <CommonLayout>
      <>
        <Box
          component="main"
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}
          ref={applicationDetailRef}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <IconButton
              aria-label="Back"
              title="Back"
              sx={{ height: 'fit-content', p: 0 }}
              component={RouterLink}
              to="/applications">
              <NavigateBeforeIcon fontSize="large" sx={{ color: 'common.black' }} />
            </IconButton>
            <Typography
              component="h1"
              sx={{ fontSize: 20, fontWeight: 600, color: 'primary.main' }}>
              Application Details
            </Typography>
          </Box>
          {dialogOpen && application && (
            <ApplicationTimeline
              id={id}
              dialogOpen={dialogOpen}
              setDialogOpen={setDialogOpen}
              consentDetails={getAuthorizedSignatoriesConsentDetails(application.groups)}
              application={application}
            />
          )}
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {editable && (
              <IconButton
                aria-label="Edit Individual Application"
                title="Edit Individual Application">
                <CardMedia
                  component="img"
                  src="/images/edit-icon-outlined.svg"
                  role="Button"
                  alt="Edit Icon"
                  sx={{ width: 'unset' }}
                  onClick={() => history.push(`/non-individual-application`, { id })}
                />
              </IconButton>
            )}
            <IconButton
              onClick={() => {
                setDialogOpen(true);
              }}
              aria-label="Activity Log"
              title="Activity Log">
              <HistoryIcon
                fontSize="inherit"
                sx={{ color: 'primary.main', width: 'inherit', fontSize: '48px' }}
              />
            </IconButton>
          </Box>
        </Box>
        <IconButton
          aria-label="Scroll to top"
          title="Scroll to top"
          sx={{
            position: 'fixed',
            right: 0,
            bottom: 75,
            borderRadius: '5px  0 0 5px',
            '&,:hover': {
              bgcolor: 'primary.main',
            },
          }}
          onClick={() => applicationDetailRef.current?.scrollIntoView({ behavior: 'smooth' })}>
          <ArrowUpwardIcon fontSize="large" sx={{ color: 'common.white' }} />
        </IconButton>
        <NonIndividualApplicationLayout
          loading={loading}
          application={application as ApplicationProps}
        />
        {editable &&
          (path === '/non-individual-application-preview/:id' ||
            APPLICATION_LISTING_STATUS[application?.status || ''] ===
              APPLICATION_LISTING_STATUS.draft ||
            APPLICATION_LISTING_STATUS[application?.status || ''] ===
              APPLICATION_LISTING_STATUS.pending_physical_sign) && (
            <Box sx={{ textAlign: 'center' }}>
              <Button
                variant="contained"
                sx={{
                  color: 'common.white',
                  minWidth: '200px',
                  mt: 4,
                  fontWeight: 600,
                  lineHeight: 1.5,
                  fontSize: '16px',
                }}
                onClick={async () => {
                  try {
                    setIsSubmitting(true);
                    const nationalitiesMdmsMasters = (await dispatch(
                      getNationalityList()
                    )) as unknown as nationaliyType;
                    const statesMdmsMasters = (await dispatch(
                      getStatesList()
                    )) as unknown as statesType;
                    const strategiesResponse = (await getAllStrategiesByDistributorType(
                      dispatch,
                      application as ApplicationProps
                    )) as unknown as GetStrategiesResponseBody[];
                    const responseRiskProfile = (await dispatch(
                      riskProfileMasterData()
                    )) as unknown as RiskProfileMaster;
                    const { applicants = [] } = application || {};
                    const getInvestorType = applicants[0]?.investorType;
                    const response = (await dispatch(getDocuments())) as unknown as any;
                    const responseFatca = (await dispatch(FatcaMdmsData())) as unknown as FatcaMdms;
                    await nonIndividualFormValidForSubmission(
                      response,
                      authorizedSignatoriesReferenceDetail,
                      application as ApplicationProps,
                      response[getInvestorType || ''] as individuals_Poa_nonIndividuals_Documents[],
                      nationalitiesMdmsMasters.countries,
                      statesMdmsMasters?.states || [],
                      true,
                      role,
                      responseRiskProfile.riskProfile,
                      strategiesResponse,
                      true,
                      responseFatca.fatca_questions
                    );
                    setIsSubmitting(false);
                    setDialog(true);
                  } catch (e) {
                    setIsSubmitting(false);
                    typeof e === 'string' && dispatch(showError(e));
                    console.error((e as Error).message);
                  }
                }}
                disabled={isSubmitting || sendBackLoading}>
                {`${'Send to Checker'} ${isSubmitting || sendBackLoading ? '...' : ''}`}
              </Button>
            </Box>
          )}
        <AccessibleDialog
          onClose={handleSendBackClose}
          open={openSendBackDialog}
          sx={{
            '.MuiPaper-root ': {
              p: 4,
              width: { xs: '70%', sm: '70%' },
            },
          }}>
          <IconButton onClick={handleSendBackClose} sx={{ alignSelf: 'flex-end' }}>
            <CloseIcon fontSize="small" />
          </IconButton>
          <Box
            sx={{
              width: { xs: '100%', sm: '80%' },
              mx: 'auto',
              '.MuiTypography-root': {
                fontSize: 18,
                fontWeight: 500,
                textAlign: 'center',
              },
            }}>
            <Typography component="h2" sx={{ color: 'primary.main', mt: 2 }}>
              {` Give Comments for ${
                application?.documentSentBack ? 'document' : 'application'
              } Send Back *`}
            </Typography>
            <Formik
              initialValues={initialCommentValues}
              onSubmit={onSendBackSubmit}
              validationSchema={Commentvalidation}>
              {({ handleSubmit }) => (
                <Box component="form" noValidate onSubmit={handleSubmit}>
                  <MFTextField
                    name="comment"
                    multiline
                    rows={4}
                    placeholder="Type your answer here..."
                  />

                  <Grid container sx={{ my: 3, justifyContent: 'center', gap: 1.5 }}>
                    <Button
                      onClick={() => {
                        handleSendBackClose();
                      }}
                      variant="outlined"
                      sx={{
                        fontSize: 15,
                        color: 'primary.main',
                        minWidth: 180,
                        letterSpacing: 2,
                        fontWeight: 500,
                      }}
                      disabled={sendBackLoading}>
                      Cancel
                    </Button>
                    <LoadingButton
                      aria-label="Continue"
                      loading={sendBackLoading}
                      variant="contained"
                      sx={{
                        fontSize: 15,
                        minWidth: 180,
                        letterSpacing: 2,
                        fontWeight: 400,
                      }}
                      type="submit">
                      Continue
                    </LoadingButton>
                  </Grid>
                </Box>
              )}
            </Formik>
          </Box>
        </AccessibleDialog>
        <ConfirmationDialog
          message={'Are you sure you want to send it to Checker?'}
          open={openDialog}
          setOpen={() => setDialog(false)}
          onSave={async () => {
            setDialog(false);
            applicationSentBack || documentSentBack ? handleSendBack() : handleSubmit();
          }}
          onCancel={() => setDialog(false)}
        />
      </>
    </CommonLayout>
  );
};
